import { HttpResponse } from '@angular/common/http';

export const collectChangedValues = (currentValues: Record<string, any> | null | undefined, nextValues: Record<string, any>) => {
  if (!currentValues) {
    return null;
  }

  const updated: Record<string, any> = {};

  Object.entries(currentValues).forEach(([key, value]) => {
    if (value !== nextValues[key]) {
      updated[key] = nextValues[key];
    }
  });

  return Object.keys(updated).length ? updated : null;
};

const getDownloadFilename = (contentDisposition: string | null) => {
  if (!contentDisposition) {
    return null;
  }

  const match = contentDisposition.match(/filename[^;=\n]*=([^;\n]*)/);

  return match?.[1] ? decodeURIComponent(match[1].replace(/["']/g, '').trim()) : null;
};

export const triggerBlobDownload = (response: HttpResponse<Blob>) => {
  const blob = response.body;
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  const filename = getDownloadFilename(response.headers.get('content-disposition'));

  anchor.href = url;

  if (filename) {
    anchor.download = filename;
  } else {
    anchor.setAttribute('download', '');
  }

  anchor.click();

  setTimeout(() => {
    anchor.remove();
    URL.revokeObjectURL(url);
  }, 100);
};

export const getResponseFilename = (response: HttpResponse<Blob>) => {
  return getDownloadFilename(response.headers.get('content-disposition'));
};
